module.exports = __webpack_public_path__ + "img/item19.27bcaa4b.png";